import useDeferredNavigation from './use-deferred-navigation'
import useTagManager from './use-tag-manager'
import {scheduleIdleAnalytics} from '../utils/common-utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export default function useCartItemNavigation({
    product,
    productUrl,
    breadcrumb,
    isExternal = false,
    resetTrackingContext = false
}) {
    const tagManager = useTagManager()
    const deferredNavigate = useDeferredNavigation()
    const {buildUrl} = useMultiSite()

    const trackProductClick = () => {
        const cartItems = document.querySelectorAll('.sf-cart-item')
        const index = [...cartItems].findIndex((element) => element.dataset.uuid === product.itemId)

        scheduleIdleAnalytics(() => {
            if (resetTrackingContext) {
                try {
                    window.__lastComponentProps = null
                } catch (error) {
                    console.warn(error.message)
                }
            }

            tagManager.productClick(
                'Cart',
                product,
                product,
                index + 1,
                breadcrumb,
                null,
                'Cart',
                undefined
            )
        })
    }

    return (event) => {
        if (window.location?.pathname?.indexOf('/cart') === -1) {
            return
        }

        if (isExternal) {
            trackProductClick()
            return
        }

        deferredNavigate(event, buildUrl(productUrl), trackProductClick)
    }
}
